import Vue from 'vue'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'RoutingGroupsForm',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    validation() {
      if (!this.proxy.type) {
        return false
      }

      if (!this.proxy.title) {
        return false
      }

      if (Array.isArray(this.proxy.RoutingRules)) {
        if (this.proxy.RoutingRules.length === 0) {
          return false
        }
        if (this.proxy.RoutingRules.some(({ id }) => {
          return id === undefined
        })) {
          return false
        }
      }

      return true
    }
  },

  watch: {
    'proxy.type'() {
      Vue.set(this.proxy, 'RoutingRules', [])
    },
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  render
}
